import PropTypes from "prop-types";
import Image from "gatsby-plugin-sanity-image";

function SingleImage({
  asset,
  alt,
  caption,
  attribution,
  orientation = "landscape",
  position = "center",
  hotspot,
  crop,
}) {
  const styleOrientation =
    orientation === "landscape"
      ? "orientationLandscape"
      : "orientationPortrait";

  const stylePosition = position || "center";
  const isInline = stylePosition.startsWith("inline");
  const cssClass = isInline
    ? `single-image single-image--${stylePosition}`
    : `my-8 md:my-12 clear-both ${[styleOrientation, stylePosition].join(" ")}`;

  return (
    <figure className={cssClass}>
      {asset && asset._id && (
        <Image
          asset={asset}
          crop={crop}
          hotspot={hotspot}
          width={isInline ? 300 : 736}
          className="align-top"
          alt={alt || ""}
        />
      )}
      {(caption || attribution) && (
        <figcaption className="max-w-4xl mx-auto px-4 md:px-0 text-xs md:text-sm py-2 text-gray-700">
          <span className="mr-1">{caption}</span>
          {attribution && (
            <span className="italic">{`Photo by ${attribution}.`}</span>
          )}
        </figcaption>
      )}
    </figure>
  );
}

SingleImage.propTypes = {
  asset: PropTypes.object,
  alt: PropTypes.string,
  caption: PropTypes.string,
  attribution: PropTypes.string,
  orientation: PropTypes.string,
  position: PropTypes.string,
  crop: PropTypes.object,
  hotspot: PropTypes.object,
};

SingleImage.defaultProps = {
  crop: { bottom: 0, left: 0, right: 0, top: 0 },
  hotspot: { height: 0.0, width: 0.0, x: 0.0, y: 0.0 },
};

export default SingleImage;
